import React from "react";
import { Skeleton } from "@mui/material";

export function VehicleSkeletonLoader() {
  const times = ["", "", "", ""];
  return (
    <div className="flex flex-row w-full h-full gap-2 p-3 border-2 border-gray-200 rounded-[12px]">
      <div className="w-24">
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={"100%"}
          animation="wave"
        />
      </div>
      <div className="grow flex flex-col">
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={"2rem"}
          animation="wave"
        />
        <div className="w-full grow flex flex-row flex-wrap gap-2 py-2">
          {times.map((_, index) => (
            <div key={index} className="w-1/3 flex flex-row gap-2">
              <Skeleton
                variant="circular"
                width={"3rem"}
                height={"3rem"}
                animation="wave"
              />
              <Skeleton
                variant="rectangular"
                width={"100%"}
                height={"3rem"}
                animation="wave"
              />
            </div>
          ))}
          <Skeleton
            variant="rectangular"
            width={"100%"}
            height={"3rem"}
            animation="wave"
          />
          <Skeleton
            variant="rectangular"
            width={"100%"}
            height={"3rem"}
            animation="wave"
          />
        </div>
      </div>
    </div>
  );
}
